import { ClientUserState } from '../ClientUserState.ts';
import { ColonistMembershipType } from '@colonist/types';
export class UIUtilsNotifications {
    static canUseLiveNotificationService() {
        var _ClientUserState_userState;
        if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) return false;
        return true;
    }
    static delayNotificationDataRequest(callback) {
        setTimeout(callback, this.REQUEST_DATA_DELAY_MS);
    }
    static getMembershipTitleFromType(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
                return {
                    key: 'strings:storePage.membership.title.elite'
                };
            case ColonistMembershipType.PlusMonthly:
            case ColonistMembershipType.PlusYearly:
                return {
                    key: 'strings:storePage.membership.title.plus'
                };
            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return {
                    key: 'strings:storePage.membership.title.premium'
                };
            case ColonistMembershipType.Holiday2023AllAccessPass:
                return {
                    key: 'strings:colonistCommon.utils.bug'
                };
        }
    }
}
UIUtilsNotifications.REQUEST_DATA_DELAY_MS = 500;
